module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAVBJREFUOE+l0z3IzlEYB+Drp0ShiDIx2ZQosZDBiEUWiUFKGUiRkpGSktGiWIR6Jx+D3UCYGZTJQkk+JnHrvD1//d+jx1Oc8Xxc932fc5/4z5Hx+apajKM4jE1YhFe4h+tJvvXxfgNVtRb3sRTX8BQ/sAUnsQZ7k7wZI/PAJPITvMaxJN+7zNq+yziAzUm+DOsDcBwnsLU/3EGP8TzJhR5o0W8kufW3O62q3biZZH0PfMa2JK2EqaOqluErViX51DYOJbTJlv4sYDla/auTfBwDL3A1yZ0ZGezEXJL2YvNjyOAM9mNHkp/TkKqaw7skp3qg1fYSD3E2SfVIVZ3GeWxM8n4BMOmFDWjP9BZX8GzUSC3iLizBoSQP/gAmyAqcwxGsaz2GD7iLS9iO22NkwV/ommZl+wvDbQ9rVbVvghxM8mgqMOM19rQ/kuTiPwFj/Bc30X4ROnnsKQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dy_home_icon_search.png
// module id = 7ngs
// module chunks = 0